export default {
    getHeaderFieldsPTBD: state => state.headerFieldsPTBD,
    getFormActions: state => state.formActions,
    getActionsPTBD: state => state.actionsPTBD,
    getRowActions: state => state.rowActions,
    getAdditionalTableConfig: state => state.dataTableOptions
}
